import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './components/HomePage';
import CustomWebsites from './components/CustomWebsites';
import CustomSaaS from './components/CustomSaaS';
import LetsLearn from './components/LetsLearn';
import ContactUs from './components/ContactUs';
import Services from './components/Services';
import TermsOfService from './components/TermsOfService';
import PrivacyPolicy from './components/PrivacyPolicy';
import ScrollToTop from './helpers/ScrollToTop';


const App = () => {
  return (
    <Router>
      <ScrollToTop/>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />
        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<Services/>} />
            <Route path="/services/custom-websites" element={<CustomWebsites />} />
            <Route path="/services/custom-saas" element={<CustomSaaS />} />
            <Route path="/lets-learn" element={<LetsLearn />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;